module.exports = __webpack_public_path__ + "img/38-6.60fe58ca.jpg";